module.exports = __webpack_public_path__ + "static/media/color-sharp2.42c4dbf6.png";